<tui-multi-select [editable]="true" [formControl]="labelControl" [tuiTextfieldLabelOutside]="true" [(search)]="search">
    Flag label(s)
    <tui-data-list-wrapper
        *tuiDataList
        tuiMultiSelectGroup
        [items]="selectLabelIcons(search)"
        [itemContent]="itemContent"
    />
</tui-multi-select>

<ng-template #itemContent let-data>
    <tui-chip [iconStart]="getIconByLabel(data)" size="s">
        {{ data }}
    </tui-chip>
</ng-template>
